export class TableItem {

    /**
     *
     * @param {Object} item -
     * @param {string} item.id - Id
     * @param {string} item.name - Nome do item.
     * @param {number} item.sort - Ordem do item.
     * @param {number} item.quantity - Quantidade do item.
     * @param {number} item.unitPrice - Preço unitário.
     * @param {number} [item.totalPrice] - Preço total.
     * @param {TableItem[]} [item.items] - Itens vinculados
     */
    constructor({ id, name, sort, quantity, unitPrice, totalPrice = 0, items = [] }) {
        /**
         * @type {number}
         */
        this.id = id;

        /**
         * @type {number}
         */
        this.name = name;
        

        /**
         * @type {number}
         */
        this.quantity = quantity;

        /**
         * @type {number}
         */
        this.sort = sort;
        

        /**
         * @type {number}
         */
        this.unitPrice = unitPrice;

        /**
         * @type {number}
         */
        this.totalPrice = totalPrice;

        /**
         * @type {TableItem[]}
         */
        this.items = items ? items.map(item => new TableItem(item)) : [];
    }

}